import _Abstract from "system/abstract"

//A simple component which just toggles a class in all immediate children of the element this component is attached to 

export default class Component_ToggleChildClasses extends _Abstract {

	constructor(el, options)
	{
		super(el, $.extend(true, {
			toggle_class:false
		}, options), 'component')

		if(!this.options.toggle_class)
		{
			console.log("Toggle Child Classes component has no toggle_class specified");
			return;
		}

		this.bindEvents()
	}


    bindEvents()
    {
      this.$el.on("click","> *",(e) => this.immediateChildClicked(e));
    }

    immediateChildClicked(e)
    {
    	console.log("immediate");
    	var $target = $(e.currentTarget);
    	if($target.hasClass(this.options.toggle_class))
    	{
    		$target.removeClass(this.options.toggle_class);
    	}
    	else
    	{
    		$target.addClass(this.options.toggle_class);
    	}
    }
}



/** WEBPACK FOOTER **
 ** ./components/toggle-child-classes.js
 **/